export const LoadingAnimationPlaceholder = () => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            xmlnsXlink="http://www.w3.org/1999/xlink"
            viewBox="0 0 160 230"
            width="160"
            height="230"
            style={{
                width: "100%",
                height: "100%",
                transform: "translate3d(0,0,0)",
                contentVisibility: "visible",
            }}
        >
            <defs>
                <path
                    fill="red"
                    d="M71 36.6C71 75.46 39.2 107 0 107s-71-31.54-71-70.4v-73.2C-71-75.46-39.2-107 0-107s71 31.54 71 70.4v73.2z"
                    id="reuse-0"
                />
                <path
                    fill="#D9E1EC"
                    d="M35.5 18.3c0 19.43-15.9 35.2-35.5 35.2s-35.5-15.77-35.5-35.2v-36.6c0-19.43 15.9-35.2 35.5-35.2s35.5 15.77 35.5 35.2v36.6z"
                    id="reuse-1"
                />
            </defs>
            <defs>
                <mask id="y" mask-type="alpha">
                    <use xlinkHref="#a" />
                </mask>
                <mask id="x" mask-type="alpha">
                    <use xlinkHref="#b" />
                </mask>
                <mask id="w" mask-type="alpha">
                    <use xlinkHref="#c" />
                </mask>
                <mask id="v" mask-type="alpha">
                    <use xlinkHref="#d" />
                </mask>
                <mask id="u" mask-type="alpha">
                    <use xlinkHref="#e" />
                </mask>
                <mask id="t" mask-type="alpha">
                    <use xlinkHref="#f" />
                </mask>
                <mask id="s" mask-type="alpha">
                    <use xlinkHref="#g" />
                </mask>
                <mask id="r" mask-type="alpha">
                    <use xlinkHref="#h" />
                </mask>
                <mask id="q" mask-type="alpha">
                    <use xlinkHref="#i" />
                </mask>
                <mask id="p" mask-type="alpha">
                    <use xlinkHref="#j" />
                </mask>
                <mask id="o" mask-type="alpha">
                    <use xlinkHref="#k" />
                </mask>
                <mask id="n" mask-type="alpha">
                    <use xlinkHref="#l" />
                </mask>
                <g style={{ display: "block" }} id="a">
                    <use transform="translate(71 108)" xlinkHref="#reuse-0" />
                    <use
                        transform="matrix(2 0 0 2 71 108)"
                        xlinkHref="#reuse-1"
                    />
                </g>
                <g style={{ display: "block" }} id="b">
                    <use transform="translate(71 108)" xlinkHref="#reuse-0" />
                    <use
                        transform="matrix(2 0 0 2 71 108)"
                        xlinkHref="#reuse-1"
                    />
                </g>
                <g style={{ display: "block" }} id="c">
                    <use transform="translate(71 108)" xlinkHref="#reuse-0" />
                    <use
                        transform="matrix(2 0 0 2 71 108)"
                        xlinkHref="#reuse-1"
                    />
                </g>
                <g style={{ display: "block" }} id="d">
                    <use transform="translate(71 108)" xlinkHref="#reuse-0" />
                    <use
                        transform="matrix(2 0 0 2 71 108)"
                        xlinkHref="#reuse-1"
                    />
                </g>
                <g style={{ display: "block" }} id="e">
                    <use transform="translate(71 108)" xlinkHref="#reuse-0" />
                    <use
                        transform="matrix(2 0 0 2 71 108)"
                        xlinkHref="#reuse-1"
                    />
                </g>
                <g style={{ display: "block" }} id="f">
                    <use transform="translate(71 108)" xlinkHref="#reuse-0" />
                    <use
                        transform="matrix(2 0 0 2 71 108)"
                        xlinkHref="#reuse-1"
                    />
                </g>
                <g style={{ display: "block" }} id="g">
                    <use transform="translate(71 108)" xlinkHref="#reuse-0" />
                    <use
                        transform="matrix(2 0 0 2 71 108)"
                        xlinkHref="#reuse-1"
                    />
                </g>
                <g style={{ display: "block" }} id="h">
                    <use transform="translate(71 108)" xlinkHref="#reuse-0" />
                    <use
                        transform="matrix(2 0 0 2 71 108)"
                        xlinkHref="#reuse-1"
                    />
                </g>
                <g style={{ display: "block" }} id="i">
                    <use transform="translate(71 108)" xlinkHref="#reuse-0" />
                    <use
                        transform="matrix(2 0 0 2 71 108)"
                        xlinkHref="#reuse-1"
                    />
                </g>
                <g style={{ display: "block" }} id="j">
                    <use transform="translate(71 108)" xlinkHref="#reuse-0" />
                    <use
                        transform="matrix(2 0 0 2 71 108)"
                        xlinkHref="#reuse-1"
                    />
                </g>
                <g style={{ display: "block" }} id="k">
                    <use transform="translate(71 108)" xlinkHref="#reuse-0" />
                    <use
                        transform="matrix(2 0 0 2 71 108)"
                        xlinkHref="#reuse-1"
                    />
                </g>
                <g style={{ display: "block" }} id="l">
                    <use transform="translate(71 108)" xlinkHref="#reuse-0" />
                    <use
                        transform="matrix(2 0 0 2 71 108)"
                        xlinkHref="#reuse-1"
                    />
                </g>
                <clipPath id="m">
                    <path d="M0 0h160v230H0z" />
                </clipPath>
            </defs>
            <g clipPath="url(#m)">
                <use
                    transform="matrix(2 0 0 2 71 108)"
                    style={{ display: "block" }}
                    xlinkHref="#reuse-1"
                />
                <g mask="url(#n)" style={{ display: "block" }}>
                    <path
                        fill="#FEFEFE"
                        d="M41.024 127.947v-.26c0-10.04-8.04-18.18-17.98-18.18-1 0-1.96.1-2.92.26-3.26-4.56-8.56-7.54-14.56-7.54-6.26 0-11.76 3.22-14.98 8.12-.48-.04-.98-.06-1.46-.06-9.68 0-17.54 7.7-17.96 17.36-5.8 1.1-10.06 6.24-10.06 12.24v1.3c0 7 5.66 12.46 12.34 12.46h64.24c6.68 0 12.34-5.46 12.34-12.46v-1.3c0-5.8-3.88-10.48-9-11.94"
                    />
                </g>
                <g mask="url(#o)" style={{ display: "block" }}>
                    <path
                        fill="#FEFEFE"
                        d="M-295.976 88.947v-.26c0-10.04-8.04-18.18-17.98-18.18-1 0-1.96.1-2.92.26-3.26-4.56-8.56-7.54-14.56-7.54-6.26 0-11.76 3.22-14.98 8.12-.48-.04-.98-.06-1.46-.06-9.68 0-17.54 7.7-17.96 17.36-5.8 1.1-10.06 6.24-10.06 12.24v1.3c0 7 5.66 12.46 12.34 12.46h64.24c6.68 0 12.34-5.46 12.34-12.46v-1.3c0-5.8-3.88-10.48-9-11.94"
                    />
                </g>
                <g mask="url(#p)" style={{ display: "block" }}>
                    <path
                        fill="#FEFEFE"
                        d="M111.005 48.069c0-.14.04-.28.04-.44 0-7.02-5.64-12.72-12.58-12.72-.78 0-1.54.1-2.26.22-2.3-3.12-5.94-5.16-10.08-5.16-4.32 0-8.12 2.2-10.4 5.54-.3-.02-.6-.08-.9-.08-6.84 0-12.36 5.48-12.56 12.34-4.06.62-7.24 4.18-7.24 8.44v1.04c0 4.66 3.86 8.56 8.48 8.56h44.98c4.88 0 8.74-3.9 8.48-8.56v-1.04c0-3.78-2.54-7.02-5.96-8.14"
                    />
                </g>
                <g mask="url(#q)" style={{ display: "block" }}>
                    <path
                        fill="#FEFEFE"
                        d="M-141.995 48.069c0-.14.04-.28.04-.44 0-7.02-5.64-12.72-12.58-12.72-.78 0-1.54.1-2.26.22-2.3-3.12-5.94-5.16-10.08-5.16-4.32 0-8.12 2.2-10.4 5.54-.3-.02-.6-.08-.9-.08-6.84 0-12.36 5.48-12.56 12.34-4.06.62-7.24 4.18-7.24 8.44v1.04c0 4.66 3.86 8.56 8.48 8.56h44.98c4.88 0 8.74-3.9 8.48-8.56v-1.04c0-3.78-2.54-7.02-5.96-8.14"
                    />
                </g>
                <g mask="url(#r)" style={{ display: "block" }}>
                    <path
                        fill="#FEFEFE"
                        d="M-45.995 78.069c0-.14.04-.28.04-.44 0-7.02-5.64-12.72-12.58-12.72-.78 0-1.54.1-2.26.22-2.3-3.12-5.94-5.16-10.08-5.16-4.32 0-8.12 2.2-10.4 5.54-.3-.02-.6-.08-.9-.08-6.84 0-12.36 5.48-12.56 12.34-4.06.62-7.24 4.18-7.24 8.44v1.04c0 4.66 3.86 8.56 8.48 8.56h44.98c4.88 0 8.74-3.9 8.48-8.56v-1.04c0-3.78-2.54-7.02-5.96-8.14"
                    />
                </g>
                <g mask="url(#s)" style={{ display: "block" }}>
                    <path
                        fill="#FEFEFE"
                        d="M-208.995 131.069c0-.14.04-.28.04-.44 0-7.02-5.64-12.72-12.58-12.72-.78 0-1.54.1-2.26.22-2.3-3.12-5.94-5.16-10.08-5.16-4.32 0-8.12 2.2-10.4 5.54-.3-.02-.6-.08-.9-.08-6.84 0-12.36 5.48-12.56 12.34-4.06.62-7.24 4.18-7.24 8.44v1.04c0 4.66 3.86 8.56 8.48 8.56h44.98c4.88 0 8.74-3.9 8.48-8.56v-1.04c0-3.78-2.54-7.02-5.96-8.14"
                    />
                </g>
                <g mask="url(#t)" style={{ display: "block" }}>
                    <path
                        fill="#FEFEFE"
                        d="M-852.771 131.069c0-.14.04-.28.04-.44 0-7.02-5.64-12.72-12.58-12.72-.78 0-1.54.1-2.26.22-2.3-3.12-5.94-5.16-10.08-5.16-4.32 0-8.12 2.2-10.4 5.54-.3-.02-.6-.08-.9-.08-6.84 0-12.36 5.48-12.56 12.34-4.06.62-7.24 4.18-7.24 8.44v1.04c0 4.66 3.86 8.56 8.48 8.56h44.98c4.88 0 8.74-3.9 8.48-8.56v-1.04c0-3.78-2.54-7.02-5.96-8.14"
                    />
                </g>
                <g mask="url(#u)" style={{ display: "block" }}>
                    <path
                        fill="#FEFEFE"
                        d="M-689.771 78.069c0-.14.04-.28.04-.44 0-7.02-5.64-12.72-12.58-12.72-.78 0-1.54.1-2.26.22-2.3-3.12-5.94-5.16-10.08-5.16-4.32 0-8.12 2.2-10.4 5.54-.3-.02-.6-.08-.9-.08-6.84 0-12.36 5.48-12.56 12.34-4.06.62-7.24 4.18-7.24 8.44v1.04c0 4.66 3.86 8.56 8.48 8.56h44.98c4.88 0 8.74-3.9 8.48-8.56v-1.04c0-3.78-2.54-7.02-5.96-8.14"
                    />
                </g>
                <g mask="url(#v)" style={{ display: "block" }}>
                    <path
                        fill="#FEFEFE"
                        d="M-785.771 48.069c0-.14.04-.28.04-.44 0-7.02-5.64-12.72-12.58-12.72-.78 0-1.54.1-2.26.22-2.3-3.12-5.94-5.16-10.08-5.16-4.32 0-8.12 2.2-10.4 5.54-.3-.02-.6-.08-.9-.08-6.84 0-12.36 5.48-12.56 12.34-4.06.62-7.24 4.18-7.24 8.44v1.04c0 4.66 3.86 8.56 8.48 8.56h44.98c4.88 0 8.74-3.9 8.48-8.56v-1.04c0-3.78-2.54-7.02-5.96-8.14"
                    />
                </g>
                <g mask="url(#w)" style={{ display: "block" }}>
                    <path
                        fill="#FEFEFE"
                        d="M-532.771 48.069c0-.14.04-.28.04-.44 0-7.02-5.64-12.72-12.58-12.72-.78 0-1.54.1-2.26.22-2.3-3.12-5.94-5.16-10.08-5.16-4.32 0-8.12 2.2-10.4 5.54-.3-.02-.6-.08-.9-.08-6.84 0-12.36 5.48-12.56 12.34-4.06.62-7.24 4.18-7.24 8.44v1.04c0 4.66 3.86 8.56 8.48 8.56h44.98c4.88 0 8.74-3.9 8.48-8.56v-1.04c0-3.78-2.54-7.02-5.96-8.14"
                    />
                </g>
                <g mask="url(#x)" style={{ display: "block" }}>
                    <path
                        fill="#FEFEFE"
                        d="M-939.751 88.947v-.26c0-10.04-8.04-18.18-17.98-18.18-1 0-1.96.1-2.92.26-3.26-4.56-8.56-7.54-14.56-7.54-6.26 0-11.76 3.22-14.98 8.12-.48-.04-.98-.06-1.46-.06-9.68 0-17.54 7.7-17.96 17.36-5.8 1.1-10.06 6.24-10.06 12.24v1.3c0 7 5.66 12.46 12.34 12.46h64.24c6.68 0 12.34-5.46 12.34-12.46v-1.3c0-5.8-3.88-10.48-9-11.94"
                    />
                </g>
                <g mask="url(#y)" style={{ display: "block" }}>
                    <path
                        fill="#FEFEFE"
                        d="M-602.751 127.947v-.26c0-10.04-8.04-18.18-17.98-18.18-1 0-1.96.1-2.92.26-3.26-4.56-8.56-7.54-14.56-7.54-6.26 0-11.76 3.22-14.98 8.12-.48-.04-.98-.06-1.46-.06-9.68 0-17.54 7.7-17.96 17.36-5.8 1.1-10.06 6.24-10.06 12.24v1.3c0 7 5.66 12.46 12.34 12.46h64.24c6.68 0 12.34-5.46 12.34-12.46v-1.3c0-5.8-3.88-10.48-9-11.94"
                    />
                </g>
                <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    stroke="#191919"
                    strokeWidth="1.002"
                    d="M-8.218-18.472h12.73m-40.049 7.927 27.32-7.93m12.729.001-36.33 37.66M35.54 8.139l-56.36.14"
                    fill="none"
                    transform="matrix(2 0 0 2 79.598 141.334)"
                    style={{ display: "block" }}
                />
                <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    stroke="#191919"
                    strokeWidth="1.25"
                    d="M35.761 18.398c0 19.54-16.02 35.39-35.76 35.39s-35.76-15.85-35.76-35.39v-36.8c0-19.54 16.02-35.39 35.76-35.39s35.76 15.85 35.76 35.39v36.8z"
                    fill="none"
                    transform="matrix(2 0 0 2 80.041 111.749)"
                    style={{ display: "block" }}
                />
            </g>
        </svg>
    );
};
